import { styled } from '@mui/material/styles';
import { Link } from 'react-router';
import { Link as MuiLink } from '@mui/material';

export const SectionTitle = styled('div')`
  color: #007ca3;
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 8px;
`;

export const SubText = styled('div')`
  font-size: 10px;
  color: #5f6670;
  font-style: italic;
`;

export const StyledLink = styled(Link)`
  cursor: pointer;
  text-underline: none;
  text-decoration: none;
  color: rgb(25, 118, 210);
`;

export const StyledMuiLink = styled(MuiLink)`
  &:hover {
    cursor: pointer;
  }
  cursor: pointer;
  text-underline: none;
  text-decoration: none !important;
`;
